import { DragOverlay, defaultDropAnimationSideEffects } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { Button, Icon } from "semantic-ui-react";

import { useCan } from "components";
import { ACL_ACTIVITIES, ACL_RESOURCES } from "models";
import { useDeletePendingChecklistMutation } from "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists/hooks";

import type { UniqueIdentifier } from "@dnd-kit/core";
import type { SortablePendingChecklists } from "modules/AppointmentDetails/components/Interventions/components/InterventionChecklists/components/PendingChecklists";
import type { CSSProperties } from "react";

type SortableItemProps = {
  item: SortablePendingChecklists;
  handleRemoveItem: (id: number) => void;
};

type DragHandleProps = {
  id: UniqueIdentifier;
};

export const SortableOverlay = () => <DragOverlay dropAnimation={{ sideEffects: defaultDropAnimationSideEffects({ styles: { active: { opacity: "0.4" } } }) }} />;

const DragHandle = ({ id }: DragHandleProps) => {
  const canReorderPendingChecklist = useCan(ACL_ACTIVITIES.Update, ACL_RESOURCES.InterventionPendingChecklist);
  const { attributes, listeners, setActivatorNodeRef } = useSortable({ id });

  return (
    <button {...attributes} {...listeners} ref={setActivatorNodeRef} className="drag-button" disabled={!canReorderPendingChecklist}>
      <Icon className="move" />
    </button>
  );
};

export const SortableItem = ({ item, handleRemoveItem }: SortableItemProps) => {
  const { isDragging, setNodeRef, transform, transition } = useSortable({ id: item.id });
  const canDeletePendingChecklist = useCan(ACL_ACTIVITIES.Delete, ACL_RESOURCES.InterventionPendingChecklist);
  const { mutate: deletePendingChecklistMutation } = useDeletePendingChecklistMutation({ handleRemoveItem });

  const style: CSSProperties = { opacity: isDragging ? 0.4 : 1, transform: CSS.Translate.toString(transform), transition };

  return (
    <li ref={setNodeRef} style={style}>
      <div className="input-wrapper">
        <div className="ordering-number">{item.ordering}</div>
        <span> {item.checklist_name} </span>
        <DragHandle id={item.id} />
      </div>

      <Button basic onClick={() => deletePendingChecklistMutation(item)} className="delete-button" icon disabled={!canDeletePendingChecklist}>
        <Icon className="trash red" />
      </Button>
    </li>
  );
};
